import { Updater, AsyncState, loadedAsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react";
import { search } from "../cmsPage/sharepointPageApi/sharepointPageApi";
import { BasePageData, PageResult } from "../cmsPage/sharepointPageApi/types/pageData";

export type SearchResult = PageResult<BasePageData>

export interface SearchState {
    query?: string
    page?: number
    result: AsyncState<SearchResult>
}

export const initialSearchState: (query?: string, page?: string) => SearchState = 
(query, page) => {
    const intPage = parseInt((page || '1'));
    return {
        result: query
            ? loadingAsyncState(() => search(query, intPage))
            : loadedAsyncState<PageResult<BasePageData>>({ Count: 0, PerPage: 10, Total: 0, Resources: [] }),
        query: query || '',
        page: intPage
    };
}

export const searchPageStateUpdaters = {
    updateSearchResult: (updater: Updater<AsyncState<SearchResult>>) =>
        (state: SearchState): SearchState => ({
            ...state,
            result: updater(state.result),
        }),
}